import type { PaymentRecord } from '@/lib/api/payments.js';

export const PAYMENT_METHOD_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'cash', label: 'Cash' },
  { value: 'card', label: 'Card' },
  { value: 'store_credit', label: 'Store Credit' },
  { value: 'loyalty_points', label: 'Loyalty Points' },
  { value: 'check', label: 'Check' },
  { value: 'other', label: 'Other' },
];

export const CARD_TYPE_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'visa', label: 'Visa' },
  { value: 'mastercard', label: 'Mastercard' },
  { value: 'amex', label: 'Amex' },
  { value: 'discover', label: 'Discover' },
  { value: 'debit', label: 'Debit' },
  { value: 'other', label: 'Other' },
];

export function paymentMethodLabel(method: string): string {
  const found = PAYMENT_METHOD_OPTIONS.find((m) => m.value === method);
  if (found) return found.label;
  return method.replaceAll('_', ' ');
}

export function paymentMethodEmoji(method: string): string {
  switch (method) {
    case 'cash':
      return '💵';
    case 'card':
      return '💳';
    case 'store_credit':
      return '🎁';
    case 'loyalty_points':
      return '⭐';
    case 'check':
      return '📝';
    default:
      return '💰';
  }
}

export function staffShortName(
  person?: { firstName?: string | null; lastName?: string | null } | null,
): string {
  if (!person?.firstName) return '';
  const last = person.lastName?.trim();
  return last ? `${person.firstName} ${last.charAt(0)}.` : person.firstName;
}

export function isPaymentVoided(payment: PaymentRecord): boolean {
  return payment.status === 'voided' || Boolean(payment.voidedAt);
}

export function paymentCardType(payment: PaymentRecord): string | null {
  return payment.cardType ?? payment.cardBrand ?? null;
}

export function paymentLastFour(payment: PaymentRecord): string | null {
  return payment.lastFour ?? payment.cardLast4 ?? null;
}

export function paymentTransactionId(payment: PaymentRecord): string | null {
  return payment.transactionId ?? payment.blockyypTransactionId ?? null;
}

export function toPaymentRecord(
  raw: Partial<PaymentRecord> & { id: string; amount: string; method: string; createdAt: string; status?: string },
): PaymentRecord {
  return {
    ...raw,
    status: raw.status ?? 'completed',
    paidAt: raw.paidAt ?? raw.createdAt,
  };
}
